<template>
  <div class="frameHome" :dir="isExamRoute ? 'ltr' : direction">
    <SimpleHeader v-if="isSimpleHeader" :dir="direction"></SimpleHeader>
    <Header :isMobile="isMobile" :dir="direction" v-else></Header>
    <div :class="[isHomePage ? 'page-full' : 'page']">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
    <Footer :isMobile="isMobile" :dir="direction"></Footer>
    <Notice></Notice>
  </div>
</template>

<script>
import Footer from '@/components/Layout/Footer.vue'
import SimpleHeader from '@/components/Layout/SimpleHeader.vue'
import Notice from '@/components/Layout/Notice.vue'
import Header from '@/components/Layout/Header.vue'
import { simpleHeaderRoutes, isRouteMatch } from '@/router/adapter'
import { mapState, mapActions } from 'vuex'
import analytics from '@/utils/AnalyticsCenter'
import { backLayerHandler } from '@/utils/utils'
import { mixinMixpanel } from '@/mixins'
import { IS_CHINA } from '@/config'
import { getRTLComputed } from '@/utils/rtl'

export default {
  name: 'app',
  components: {
    Header,
    SimpleHeader,
    Footer,
    Notice,
  },
  mixins: [mixinMixpanel],
  provide() {
    return {
      //父组件中通过provide来提供变量，在子组件中通过inject来注入变量
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
      isMobile: false,
      isAllowJump: false,
    }
  },
  computed: {
    ...mapState({
      currentLevelActiveId: (state) => state.level.levelActive,
    }),
    ...getRTLComputed(),
    isExamRoute() {
      const name = this.$route.name || ''
      const path = this.$route.path || ''
      const examNames = [
        'Simulation',
        'SimulationTri',
        'SimulationHigh',
        'SimulationHskk',
      ]
      const examPaths = [
        '/hsk/simulation',
        '/hsk/simulationTri',
        '/hsk/simulationHigh',
        '/hsk/simulationHskk',
      ]
      return (
        examNames.includes(name) || examPaths.some((p) => path && path.indexOf(p) > -1)
      )
    },
    isSimpleHeader() {
      return isRouteMatch(simpleHeaderRoutes, this.$route.path)
    },
    isHomePage() {
      return (
        this.$route.name == 'HomeIndex' ||
        this.$route.name == 'HomeSzu' ||
        this.$route.name == 'ForTeachersIndex' ||
        this.$route.name == 'SolutionsIndex' ||
        this.$route.name == 'AssignmentDetail' ||
        this.$route.name == 'PartnerFormsIndex' ||
        this.$route.name == 'AddSchoolIndex' ||
        this.$route.name == 'JoinCampusIndex' ||
        this.$route.name == 'spcMobileGuidances' ||
        this.$route.name == 'ChooseLevel' ||
        this.$route.name == 'AboutIndex' ||
        (this.isMobile && this.$route.name == 'ProfileStep')
      )
    },
    isChina() {
      return IS_CHINA
    },
  },
  beforeMount() {
    this.$_resizeHandler()
    window.addEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    const clientWidth = document.documentElement.clientWidth
    if (clientWidth <= 980) {
      this.clientClass = 'main_980'
    } else if (clientWidth > 980 && clientWidth < 1144) {
      this.clientClass = 'main_1080'
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  methods: {
    ...mapActions({
      refreshLevelList: 'level/refreshLevelList',
    }),
    reload() {
      this.isRouterAlive = false //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true //再打开
      })
    },
    $_resizeHandler() {
      this.isMobile = document.body.getBoundingClientRect().width - 1 < 768
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isMobile && from.fullPath == '/home/index' && this.isAllowJump) {
      this.isAllowJump = false
      let mixpanelParams = { people_id: this.peopleId, unlimited: this.unlimited }
      backLayerHandler(
        () => {
          analytics.logEvent('hskweb_mobileremind_click', { type: 'confirm' })
          next(false)
          analytics.logEvent('hskweb_android_click', mixpanelParams)
          window.open(
            this.$store.state.publicUrl.mockPublicUrl +
              '/static/android/com.wohui.mocktest-foreign-prod.apk'
          )
          // window.open(
          //   (this.isChina ? this.$store.state.publicUrl.mockPublicUrl : "https://mock-public.wohui.co") +
          //     "/static/android/com.wohui.mocktest-foreign-prod.apk",
          // );
        },
        {
          type: 'default',
          msg: this.$t('download_app_mobile'),
          cancel: () => {
            analytics.logEvent('hskweb_mobileremind_click', { type: 'cancel' })
            //取消阻止本次返回跳转，回归到本页面url
            // next();
          },
        }
      )
    } else {
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
.frameHome {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fafafb;
  height: 100vh;
  overflow: auto;
  .page {
    width: 1200px;
    margin: 16px auto;
    flex: 1;
  }
  .page-full {
    width: 100%;
    margin: 0;
    flex: 1;
  }
}

@media (max-width: 768px) {
  .frameHome {
    .page {
      width: 100%;
    }
  }
}
</style>
